import React from "react";
import "./header.css";

const Header = () => {
  return (
    <header>
      <div className="App-header">
        <div className="header_img_container">
          <img src="/precision_logo.png" />
        </div>
      </div>
    </header>
  );
};
export default Header;
